<template>
  <div id="article-list">
    <div class="article-content" v-if="pageData.content != null && pageData.content.length > 0" v-for="article in pageData.content" >
      <div class="article-item" v-if="article != null" @click="clickDetails(article.id)">
        <!--<div class="article-pic"><img v-bind:src="cover" alt="标题"></div>-->
        <div class="article-title"><h3>{{article.title}}</h3></div>
        <div class="article-introduces"><p>{{article.introduction}}</p></div>
        <div v-show="article.showDetails"><p>{{article.content}}</p></div>
      </div>
    </div>
    <div class="article-page" @mouseleave="clickMoreLeave">
      <div class="article-number" v-if="pageData.last">
        <span @click="clickNoMore">{{tableName.noMore[noMoreIndex]}})</span><span v-show="wannaReSet" @click="clickReSet">{{tableName.reSet}}</span>
      </div>
      <div class="article-number" v-else>
        <span @click="clickPrevious">{{tableName.prePage}}</span>
        <span @click="clickMore">{{tableName.loadMore}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import {articleList} from "../../api/api";

  export default {
    name: "MyArticles",
    props: {
      page: {
        type: Number,
        default: 0
      },
      size: {
        type: Number,
        default: 5
      },
      queryVo: {
        type: Object,
        default: function () {
          return {};
        }
      }
    },
    data: function () {
      return {
        pageData: {
          content: [],
          last: false,
          number: 0
        },
        tableName: {
          noMore: ['没有更多啦(*^o^*)','哦豁(*^o^*)','乖乖(*^o^*)','亲亲(*^o^*)'],
          loadMore: '下一页',
          prePage: '上一页',
          reSet: '重置',
        },
        wannaReSet: false,
        noMoreIndex: 0,
        cover: "./../../../static/pic/docker-1.png"
      }
    },
    created(){
      this.searchQuery(this.page, this.size);
    },
    updated() {
    },
    methods: {
      articleList: function (params) {
        debugger;
        const res = articleList(params);
        res.then(x => {
          console.log(x);
          this.pageData = x.data.data;
          console.log("searchResult-searchAction:", this.pageData.last);
          this.$emit('searchResult', this.pageData.last, this.pageData.number);
          debugger;
        })
      },
      searchQuery: function(page, size) {
        console.log(page, size, this.page, this.size, this.queryVo, 'searchQuery');
        this.articleList({
          page: page,
          size: size
        })
      },
      clickPrevious: function () {
        console.log("clickPrevious-getPageLast:",this.pageData.last, this.page, this.pageData.number, this.size);
        if (!this.pageData.last){
          this.pageData.number -= 1;
          this.searchQuery(this.pageData.number, this.size);
        }
      },
      clickMore: function () {
        console.log("clickMore-getPageLast:",this.pageData.last, this.page, this.pageData.number, this.size);
        if (!this.pageData.last){
          this.pageData.number += 1;
          this.searchQuery(this.pageData.number, this.size);
          this.randomOne();
        }
      },
      clickNoMore: function () {
        console.log("clickNoMore-getPageLast:",this.pageData.last, this.page, this.pageData.number, this.size);
        if (this.pageData.last){
          this.wannaReSet = !this.wannaReSet;
          this.randomOne();
        }
      },
      clickReSet: function () {
        console.log("clickReSet-getPageLast:",this.pageData.last, this.page, this.pageData.number, this.size);
        this.pageData.number = 0;
        this.wannaReSet = false;
        this.searchQuery(this.pageData.number, this.size);
      },
      clickMoreLeave: function () {
        console.log("clickMoreLeave-getPageLast:",this.pageData.last, this.page, this.pageData.number, this.size);
      },
      randomOne: function () {
        console.log("randomOne-getPageLast:",this.pageData.last, this.page, this.pageData.number, this.size);
        this.noMoreIndex = Math.floor(Math.random() * this.tableName.noMore.length);
        console.log(this.noMoreIndex, 'randomOne');
      },
      clickDetails: function (id) {
        console.log("clickDetails-id:", id);
        this.$router.push({
          name: 'HomeArticleDetails',
          params: {
            //id: id
          },
          query: {
            id: id//页面会有这个值
          }
        })
      }
    }
  }
</script>

<style scoped>
  #article-list {
    margin: 0 auto;
    padding: 0;
    border: 0;
    display: inline-block;
    vertical-align: middle;
    width: 100%;
  }
  #article-list .article-content {
    display: table;
    vertical-align: middle;
    width: 100%;
  }
  #article-list .article-content .article-item {
    display: table-cell;
    vertical-align: middle;
    width: 100%;
    border-style: dotted;
    border-color: #797979;
    border-width: 2px;
    border-radius: 10px;
    animation: border-color-move 4s infinite linear alternate;
  }
  #article-list .article-content .article-item .article-title {
    display: table-cell;
    flex-direction: row;
    vertical-align: middle;
    max-width: 200px;
    min-width: 200px;
    border-style: dotted;
    border-color: #797979;
    border-width: 0 2px 0 0;
    animation: border-color-move 2s infinite linear alternate;
  }
  #article-list .article-content .article-item .article-title h3{
    overflow: hidden;
    text-overflow: ellipsis;
  }
  #article-list .article-content .article-item .article-introduces {
    display: table-cell;
    flex-direction: row;
    vertical-align: middle;
    width: 100%;
  }
  #article-list .article-content .article-item .article-introduces p{
    margin: 5px;
    width: 520px;
    display: -webkit-box;
    -webkit-box-orient: vertical;/*子元素垂直排列*/
    line-clamp: 2;
    -webkit-line-clamp: 2;/*限制两行*/
    word-break: break-all;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  #article-list .article-page {
    display: flex;
    vertical-align: middle;
    flex-direction: column;/*竖直方向布局*/
    width: auto;
    border-style: dotted;
    border-color: #797979;
    border-width: 1px;
  }
  #article-list .article-page .article-number{
    display: inline-block;
    margin: auto;
    line-height: 1.8em;
    /*background: #ff8f65;*/
    border-style: solid;
    border-color: #c26753;
    border-width: 2px;
  }
  #article-list .article-page .article-number span{
    vertical-align: middle;
    margin: 0 10px;
    font-size: 1.25em;
    background: #ff8f65;
    border-radius: 5px;
    border-style: solid;
    border-color: #723e2e;
    border-width: 1px;
    box-shadow: 0 0 20px #d77954;/*x y 模糊 颜色阴影*/
  }
  #article-list .article-page .article-number span::before {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #f9c4d2;
    border-radius: inherit;
  }
  #article-list .article-page .article-number span:hover {
    background: #f9c4d2;
    border-color: #f9c4d2;
    box-shadow: 0 0 20px #ed2c48;/*x y 模糊 颜色阴影*/
  }
  #article-list .article-page .article-number span:active {
    background: #ffe9e9;
    color: #9fc1ff;
    border-color: #9fc1ff;
  }
  /*规定动画*/
  @keyframes border-color-move {
    0% { border-color: #2fffbb;}
    25% { border-color: #ffdc51;}
    50% { border-color: #ff68e3;}
    75% { border-color: #2dccff;}
    100% { border-color: #34ff78;}
  }
</style>



// WEBPACK FOOTER //
// src/components/user/MyArticles.vue